import { Shield, FileText, DollarSign } from "lucide-react";

export const logoLinks = [
  {
    label: "Политика конфиденциальности",
    icon: Shield,
    href: "/pages/privacy",
  },
  { label: "Оферта", icon: FileText, href: "/pages/offer" },
  {
    label: "Добавить свой объект",
    icon: DollarSign,
    href: "https://gostim.ru/",
  },
];
